import React, { Component } from 'react';
import cloudLogo from '../assets/logo/cloud.png';
import k8sLogo from '../assets/logo/k8s.png';
import dockerLogo from '../assets/logo/docker.png';
import hadoopLogo from '../assets/logo/hadoop.png';
import sparkLogo from '../assets/logo/spark.png';
import kafkaLogo from '../assets/logo/kafka.png';
import airflowLogo from '../assets/logo/airflow.png';
import kubeflowLogo from '../assets/logo/kubeflow.png';
import mlflowLogo from '../assets/logo/mlflow.jpeg';
import databricksLogo from '../assets/logo/databricks.png';
import terraformLogo from '../assets/logo/terraform.png';
import jupyterLogo from '../assets/logo/jupyter.png';
import atlasLogo from '../assets/logo/atlas.png';
import rangerLogo from '../assets/logo/ranger.jpg';
import clouderaLogo from '../assets/logo/cloudera.png';
import argoLogo from '../assets/logo/argo.png';
import deltalakeLogo from '../assets/logo/delta_lake.png';
import parquetLogo from '../assets/logo/parquet.jpeg';
import openshiftLogo from '../assets/logo/openshift.png';
import rancherLogo from '../assets/logo/rancher.jpeg';
import datahubLogo from '../assets/logo/datahub.png';
import geLogo from '../assets/logo/great_expectations.png';
import feastLogo from '../assets/logo/feast.png';
import prestoLogo from '../assets/logo/presto.png';
import trinoLogo from '../assets/logo/trino.png';
import monitoringLogo from '../assets/logo/prometheus_grafana.jpeg';
import icebergLogo from '../assets/logo/iceberg.png';
import claudeCodeLogo from '../assets/logo/claude_code.png';
import cursorLogo from '../assets/logo/cursor.png';
import codexLogo from '../assets/logo/openai.png';
import langchainLogo from '../assets/logo/langchain.png';
import langgraphLogo from '../assets/logo/langgraph.png';
import langfuseLogo from '../assets/logo/langfuse.png';
import ollamaLogo from '../assets/logo/ollama.png';
import dbtLogo from '../assets/logo/dbt.png';
import flinkLogo from '../assets/logo/flink.png';
import snowflakeLogo from '../assets/logo/snowflake.png';
import pythonLogo from '../assets/logo/python.png';
import dagsterLogo from '../assets/logo/dagster.png';
import openMetadataLogo from '../assets/logo/open_metadata.png';
import amundsenLogo from '../assets/logo/amundsen.png';
import duckdbLogo from '../assets/logo/duckdb.png';
import postgresLogo from '../assets/logo/postgresql.png';
import elasticLogo from '../assets/logo/elastic.png';
import spinnakerLogo from '../assets/logo/spinnaker.png';

const logos = [
  { logo: claudeCodeLogo, name: 'Claude Code' },
  { logo: codexLogo, name: 'OpenAI Codex' },
  { logo: cursorLogo, name: 'Cursor' },
  { logo: langchainLogo, name: 'LangChain' },
  { logo: langgraphLogo, name: 'LangGraph' },
  { logo: langfuseLogo, name: 'Langfuse' },
  { logo: ollamaLogo, name: 'Ollama' },
  { logo: cloudLogo, name: 'Cloud' },
  { logo: k8sLogo, name: 'Kubernetes' },
  { logo: dockerLogo, name: 'Docker' },
  { logo: monitoringLogo, name: 'Prometheus & Grafana' },
  { logo: hadoopLogo, name: 'Hadoop' },
  { logo: sparkLogo, name: 'Spark' },
  { logo: kafkaLogo, name: 'Kafka' },
  { logo: flinkLogo, name: 'Apache Flink' },
  { logo: airflowLogo, name: 'Airflow' },
  { logo: dagsterLogo, name: 'Dagster' },
  { logo: dbtLogo, name: 'dbt' },
  { logo: pythonLogo, name: 'Python' },
  { logo: kubeflowLogo, name: 'Kubeflow' },
  { logo: mlflowLogo, name: 'MLflow' },
  { logo: feastLogo, name: 'Feast' },
  { logo: databricksLogo, name: 'Databricks' },
  { logo: snowflakeLogo, name: 'Snowflake' },
  { logo: terraformLogo, name: 'Terraform' },
  { logo: jupyterLogo, name: 'Jupyter' },
  { logo: atlasLogo, name: 'Apache Atlas' },
  { logo: rangerLogo, name: 'Apache Ranger' },
  { logo: clouderaLogo, name: 'Cloudera' },
  { logo: argoLogo, name: 'Argo' },
  { logo: deltalakeLogo, name: 'Delta Lake' },
  { logo: icebergLogo, name: 'Iceberg' },
  { logo: parquetLogo, name: 'Parquet' },
  { logo: prestoLogo, name: 'Presto' },
  { logo: trinoLogo, name: 'Trino' },
  { logo: duckdbLogo, name: 'DuckDB' },
  { logo: postgresLogo, name: 'PostgreSQL' },
  { logo: elasticLogo, name: 'Elastic' },
  { logo: openshiftLogo, name: 'OpenShift' },
  { logo: rancherLogo, name: 'Rancher' },
  { logo: datahubLogo, name: 'DataHub' },
  { logo: openMetadataLogo, name: 'Open Metadata' },
  { logo: amundsenLogo, name: 'Amundsen' },
  { logo: geLogo, name: 'Great Expectations' },
  { logo: spinnakerLogo, name: 'Spinnaker' },
];

class Logo extends Component {
  render() {
    return (
      <ul className="logo-grid">
        {logos.map(item => (
          <li className="logo-cell" key={item.name} title={item.name}>
            <img src={item.logo} alt={item.name} />
          </li>
        ))}
      </ul>
    );
  }
}

export default Logo;
